// native
import { Component, ChangeDetectionStrategy } from '@angular/core';

// service
import { AuthService } from '../core/services/auth.service';
import { GlobalsService } from '../core/services/globals.service';
import { UserService } from '../core/services/user.service';

@Component({
  selector: 'scs-subscription',
  templateUrl: './subscription.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionComponent {

  webappUrl: string;

  constructor(
    private authService: AuthService,
    public userService: UserService,
    private globalsService: GlobalsService
  ) {
    this.webappUrl = this.globalsService.appConfig.environment.baseUrls.webapp;
  }

  onLogoutClick() {
    this.authService.signout();
  }
}
